/**
 * data-panel — Generic slide panel / offcanvas component
 *
 * Attributes:
 *   data-panel="<name>"          Panel element (slides in/out)
 *   data-panel-overlay="<name>"  Overlay backdrop
 *   data-panel-open="<name>"     Trigger to open
 *   data-panel-close="<name>"    Trigger to close
 *   data-panel-lock-scroll       (presence) Lock body scroll when open
 */

document.addEventListener('DOMContentLoaded', () => {
    function openPanel(name) {
        const panel = document.querySelector(`[data-panel="${name}"]`)
        const overlay = document.querySelector(`[data-panel-overlay="${name}"]`)
        if (!panel || !overlay) return

        overlay.classList.remove('tw:hidden')
        panel.classList.remove('tw:translate-x-full')

        if (panel.hasAttribute('data-panel-lock-scroll')) {
            document.body.style.overflow = 'hidden'
        }
    }

    function closePanel(name) {
        const panel = document.querySelector(`[data-panel="${name}"]`)
        const overlay = document.querySelector(`[data-panel-overlay="${name}"]`)
        if (!panel || !overlay) return

        panel.classList.add('tw:translate-x-full')
        setTimeout(() => {
            overlay.classList.add('tw:hidden')
        }, 300)

        if (panel.hasAttribute('data-panel-lock-scroll')) {
            document.body.style.overflow = ''
        }
    }

    // Open triggers
    document.querySelectorAll('[data-panel-open]').forEach(trigger => {
        trigger.addEventListener('click', () => {
            openPanel(trigger.getAttribute('data-panel-open'))
        })
    })

    // Close triggers
    document.querySelectorAll('[data-panel-close]').forEach(trigger => {
        trigger.addEventListener('click', () => {
            closePanel(trigger.getAttribute('data-panel-close'))
        })
    })

    // Close via overlay click
    document.querySelectorAll('[data-panel-overlay]').forEach(overlay => {
        overlay.addEventListener('click', () => {
            closePanel(overlay.getAttribute('data-panel-overlay'))
        })
    })

    // Close via Escape key
    document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return

        document.querySelectorAll('[data-panel-overlay]').forEach(overlay => {
            if (!overlay.classList.contains('tw:hidden')) {
                closePanel(overlay.getAttribute('data-panel-overlay'))
            }
        })
    })
})
